import RestApiModel from "@/api/Model/RestApiModel";

class Application extends RestApiModel {
  static ApplicationOrionId = 1;

  static getResourceEndpoint() {
    return '/applications';
  }
}

export default Application;
